import { api_base } from '../api';
import Store from '../store';

export const Search = {
  search(query, cb) {
    // Set true to show the loader.
    Store.state.results = [];
    Store.state.searching_product = true;

    $.ajax({
      url: api_base + '/search/' + query,
      method: 'GET',

      success: function (res) {
        cb(res);
        Store.state.searching_product = false;
      },

      error: function (err) {
        if (err.status == 500) {
          return toast({
            title: 'Servidor',
            content: 'Problemas con el servidor.'
          });
        }

        // console.log(err);
      }
    });
  }
};


// WEBPACK FOOTER //
// ./src/store/api/search.js